<app-page-meta pageTitle="Low Interest Personal Loans | Get easy loans online in India - finzy"
               tags="quick personal loans, low interest personal loans, easy loans online, personal loans, cheapest loans india, peer to peer lending, peer to peer lending india, line of credit online, easy finance, need a loan, india credit finance, current loan rates india, best loans india, best loan rates"
               description="Get the cheapest loans in India to fund your next purchase. Finzy provides you quick personal loans at interest rates as low as 7.99%. Know more about these collateral free, easy loans online with the quickest turnaround time. Finzy connects personal loan borrowers with investors.">
</app-page-meta>

<app-json-ld-schema schemaData="{{ schemaData }}"></app-json-ld-schema>

<div class="badge hidden-xs visible-md-block visible-lg-block"
     [routerLink]="['/articles/finzy-gets-nbfc-p2p-certificate']">
    <img src="../../../assets/images/finzy_rbi_badge.png">
</div>

<app-header [secondaryLogoUrl]="partnerLogoUrl"></app-header>
<div class="cibil_rectangle d-flex justify-content-between flex-row p-5 mh-75">
    <div class="image_content d-none d-md-flex align-center align-items-center">
        <img src="../../../assets/images/cibil/cibil_small.png" class="mr-2">
        <p class="m-2">
            <span class="text-white font-bold medium-big-text">Check Your Free CIBIL Score</span><br/>
            <span class="image_text">Instantly for Free | No Impact on Your Score</span>
        </p>
    </div>
    <div class="d-none d-md-block">
        <button mat-stroked-button class="primary" type="submit"
            (click)="cibilCheckClick()"
        >
        GET YOUR CIBIL SCORE
        </button>
    </div>

    <!-- Mobile Responsive Design -->
    <div class="d-md-none flex-column w-100">
        <div class="image_content d-flex align-center align-items-center">
            <img src="../../../assets/images/cibil/cibil_small.png" class="mr-2">
            <p class="m-2">
                <span class="text-white font-bold medium-big-text">Check Your Free CIBIL Score</span><br/>
                <span class="image_text">Instantly for Free | No Impact on Your Score</span>
            </p>
        </div>
        <div>
            <button mat-stroked-button class="primary w-100" type="submit"
                (click)="cibilCheckClick()"
            >
            GET YOUR CIBIL SCORE
            </button>
        </div>
    </div>
</div>
<div class="row custrow">
    <div class="bannerimage">
        <div class="bannerdiv">
            <div class="bannerinnerdiv">
                <h1 class="bannertxt1">Quick personal loans <br/> starting at <span class="highlighted-banner-text">10.99%</span>
                    p.a.
                </h1>

                <div class="row headcontainer">
                    <form #d="ngForm" (ngSubmit)="submitForm(d.value)" (keydown.enter)="$event.preventDefault()">
                        <div class="col-sm-4 loancont">
                            <p class="ptexth1">Loan Amount</p>
                            <mat-form-field style="width:80%">
                                <input matInput class="tenureinput" placeholder="Upto 5,00,000" type="number"
                                       (keyup)="onKey($event)"
                                       [min]="minimumLoanAmount" step="1000" max="500000" name="loanamt"
                                       [(ngModel)]="loanamt">
                            </mat-form-field>
                            <span class="errormsg3"
                                  *ngIf="errorMsgRange">Loan amount should be between Rs {{minimumLoanAmount}} and Rs 5,00,000</span>
                            <span class="errormsg"
                                  *ngIf="errorMsgMult">Loan amount should be in multiples of 1,000</span>
                            <span class="errormsg" *ngIf="errorMsgLoan">Please fill out loan amount</span>
                        </div>
                        <div class="col-sm-4 loancont">
                            <p class="ptexth1">Loan Purpose</p>
                            <mat-form-field>
                                <mat-select placeholder="Select purpose" name="loanpurpose"
                                            (selectionChange)="loanPurposeChange($event)"
                                            [(ngModel)]="loanpurpose" style="width:100%">
                                    <mat-option *ngFor="let loanpurpose of loanpurposes"
                                                [value]="loanpurpose" required>
                                        {{ loanpurpose }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <span class="errormsg2" *ngIf="errorMsgPurpose">Please fill out loan purpose</span>
                        </div>
                        <div class="col-sm-2 loancont">
                            <p class="ptexth1 ptexth1res">Tenure</p>
                            <mat-form-field style="width:80%">
                                <mat-select placeholder="Select tenure" name="loanTenure"
                                            (selectionChange)="loanTenureChange()"
                                            [(ngModel)]="loanTenure" style="width:100%">
                                    <mat-option *ngFor="let loanTenure of loanTenures"
                                                [value]="loanTenure" required>
                                        {{ loanTenure }} months
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                            <span class="errormsg2" *ngIf="errorMsgTenure">Please select a tenure</span>
                        </div>
                        <div class="col-sm-2 mt-5">
                            <button mat-flat-button class="primary" type="submit"
                                    (click)="analyticsTracker.trackButtonClick('Borrower Home' , 'Apply Now', 'Banner'); tracker.trackButtonClick()">
                                APPLY NOW
                            </button>
                        </div>

                    </form>
                    <p class="form_text"><i>Prepay anytime. No prepayment penalties.</i></p>
                </div>
                <div class="row headcont">
                    <div class="col-sm-3 nopadding">
                        <h3 class="bannertxt3">Secure Digitised Processes</h3>
                    </div>
                    <div class="col-sm-3 nopadding">
                        <h3 class="bannertxt3">Savings on interest</h3>
                    </div>
                    <div class="col-sm-3 nopadding">
                        <h3 class="bannertxt3">No lock-in period</h3>
                    </div>
                    <div class="col-sm-3 nopadding">
                        <h3 class="bannertxt4">No part payment charges</h3>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row custcontainer" id="howitworks">
    <h2 class="howtext">How finzy works</h2>
    <p class="howtext2">finzy connects personal loan borrowers with investors</p>
    <div class="how_finzy_works_icons_div">
        <div class="icon-div" style="">
            <div class="icon-inner-div">
                <i class="fa fa-glass1 icon-has-background hover-icon-has-border icon-custom icon-bg-style"
                   style=""></i>
            </div>
            <p class="how_icon_descr">Digitally Connect borrowers<br>and investors</p>
        </div>
        <div class="icon-div" style="">
            <div class="icon-inner-div">
                <i class="fa fa-glass2 icon-has-background hover-icon-has-border icon-custom icon-bg-style"></i>
            </div>
            <p class="how_icon_descr">Documentation &<br>Disbursement of Loans</p>
        </div>
        <div class="icon-div" style="">
            <div class="icon-inner-div">
                <i class="fa fa-glass3 icon-has-background hover-icon-has-border icon-custom icon-bg-style"></i>

            </div>
            <p class="how_icon_descr">Automated monthly EMI<br>collection & transfer</p>
        </div>

    </div>
</div>

<div class="row custcontainer2" id="successstories">
    <h2 class="howtext">What do I need to do for a Personal Loan</h2>
    <p class="howtext3">finzy makes entire borrowing process simple and user friendly</p>
    <p class="howtext2 howtext2inner">You can get your loan funded in as little as 48 hours </p>
    <div class="imgmid">
        <img src="https://res.cloudinary.com/finzy/image/upload/v1498288560/borrower_2div_ghvugv.png"
             alt="finzy borrowing process" class="desktop">
        <img src="https://res.cloudinary.com/finzy/image/upload/v1496520772/borrowermid_fuyhtd.png"
             alt="finzy borrowing process" class="mob">
    </div>
</div>

<div class="why_invest_finzy row custcontainer3" id="whyborrow">
    <h2 class="title">Why Borrow With finzy</h2>
    <p class="description">We strive to get you the loan in quickest turn around time, at lowest rate of interest and in
        a
        hassle free manner.</p>

    <div id="myCarousel" class="carousel slide" data-ride="carousel" data-interval="false">

        <ol class="carousel-indicators">
            <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
            <li data-target="#myCarousel" data-slide-to="1"></li>
            <li data-target="#myCarousel" data-slide-to="2"></li>
            <li data-target="#myCarousel" data-slide-to="3"></li>
            <li data-target="#myCarousel" data-slide-to="4"></li>
        </ol>

        <div class="carousel-inner">

            <div class="item active">
                <div class="credit_algorithm">
                    <div class="credit_algo_div">
                        <div class="credit_title">
                            Quick. Easy
                        </div>

                        <div class="credit_algo_list">
                            <ul>
                                <li>
                                    <p class="credit_algo_list_p_li">
                                        Online loan application process
                                    </p>
                                </li>
                                <li>
                                    <p class="credit_algo_list_p_li">
                                        Loans funded in as less as 48 hours
                                    </p>
                                </li>
                                <li>
                                    <p class="credit_algo_list_p_li">
                                        finzy facilitates execution of loan agreement either digitally or at your
                                        doorstep
                                    </p>
                                </li>

                            </ul>
                        </div>

                        <div class="invest_btn" [routerLink]="['/borrow/intro']"
                             (click)="analyticsTracker.trackButtonClick('Borrower Home', 'Borrow Now' , 'First Carousel Display')">
                            BORROW NOW
                        </div>
                    </div>
                    <div class="credit_algo_image">
                        <img src="https://res.cloudinary.com/finzy/image/upload/v1496667973/Group_29_y89deb.png"
                             alt="Quick & Easy loan application" style="height: 270px;">
                    </div>

                </div>
            </div>

            <div class="item">
                <div class="credit_algorithm">
                    <div class="credit_algo_div">
                        <div class="credit_title">Flexibility and Transparency</div>
                        <div class="credit_algo_list">
                            <p class="credit_algo_list_p">
                                At finzy we provide you the benefit of a low monthly EMI, thanks to our 36 month loan
                                tenure. You also
                                have the ability to prepay your loan fully or partially whenever you want with no
                                penalties incurred.
                            </p>
                            <ul>
                                <li>
                                    <p class="credit_algo_list_p_li">
                                        No hidden charges
                                    </p>
                                </li>
                                <li>
                                    <p class="credit_algo_list_p_li">
                                        No lock-in
                                    </p>
                                </li>
                                <li>
                                    <p class="credit_algo_list_p_li">
                                        Visual dashboards to track your transactions
                                    </p>
                                </li>
                            </ul>
                        </div>

                        <div class="invest_btn" [routerLink]="['/borrow/intro']"
                             (click)="analyticsTracker.trackButtonClick('Borrower Home', 'Borrow Now' , 'Second Carousel Display')">
                            BORROW NOW
                        </div>
                    </div>
                    <div class="credit_algo_image">
                        <img src="https://res.cloudinary.com/finzy/image/upload/v1496670142/ba_pshedr.png"
                             alt="Flexible and transparent process" style="margin-top: 10%">
                    </div>
                </div>
            </div>

            <div class="item">
                <div class="credit_algorithm">
                    <div class="credit_algo_div">
                        <div class="credit_title">Security and Privacy</div>
                        <div class="credit_algo_list">
                            <ul>
                                <li>
                                    <p class="credit_algo_list_p_li">
                                        Your personal information is never revealed to evaluating investors
                                    </p>
                                </li>
                                <li>
                                    <p class="credit_algo_list_p_li">
                                        Loans funded only by screened investors
                                    </p>
                                </li>
                                <li>
                                    <p class="credit_algo_list_p_li">
                                        finzy assures your personal data is secure and not shared or misused
                                    </p>
                                </li>
                                <li>
                                    <p class="credit_algo_list_p_li">
                                        finzy remains your contact point despite loans being funded by multiple
                                        investors
                                    </p>
                                </li>
                            </ul>
                        </div>

                        <div class="invest_btn" [routerLink]="['/borrow/intro']"
                             (click)="analyticsTracker.trackButtonClick('Borrower Home', 'Borrow Now' , 'Third Carousel Display')">
                            BORROW NOW
                        </div>
                    </div>
                    <div class="credit_algo_image">
                        <img src="https://res.cloudinary.com/finzy/image/upload/v1496667973/Group_28_mxygt4.png"
                             alt="Security and Privacy of Personal information" style="height: 300px;">
                    </div>
                </div>
            </div>

            <div class="item">
                <div class="credit_algorithm">
                    <div class="credit_algo_div">
                        <div class="credit_title">
                            Credit Assessment
                        </div>

                        <div class="credit_algo_list">
                            <p class="credit_algo_list_p">
                                Our evaluation process goes beyond the traditional approach of banks.
                            </p>
                            <p class="credit_algo_list_p">
                                By assessing borrowers on multiple parameters and not limited to just credit score or
                                only to employees
                                of Selective Corporate, we are able to offer loans to a much larger borrower segment
                            </p>
                        </div>

                        <div class="invest_btn" [routerLink]="['/borrow/intro']"
                             (click)="analyticsTracker.trackButtonClick('Borrower Home', 'Borrow Now' , 'Fourth Carousel Display')">
                            BORROW NOW
                        </div>
                    </div>
                    <div class="credit_algo_image">
                        <img src="https://res.cloudinary.com/finzy/image/upload/v1494580845/invest/Group_22.png"
                             alt="Credit assessment on multiple parameters" style="height: 300px;">
                    </div>
                </div>
            </div>
            <div class="item">
                <div class="credit_algorithm">
                    <div class="credit_algo_div">
                        <div class="credit_title">
                            Multiple Loans
                        </div>

                        <div class="credit_algo_list">
                            <p class="credit_algo_list_p">
                                Being responsible pays off - Customers with great borrowing track record on finzy can
                                access
                                loans from finzy multiple times while their current loan and its terms remain unchanged.
                            </p>
                        </div>

                        <div class="invest_btn" [routerLink]="['/borrow/intro']"
                             (click)="analyticsTracker.trackButtonClick('Borrower Home', 'Borrow Now' , 'Fourth Carousel Display')">
                            BORROW NOW
                        </div>
                    </div>
                    <div class="credit_algo_image">
                        <img src="../../../../assets/images/why-finzy/multiple-loan.svg"
                             alt="Credit assessment on multiple parameters" style="height: 300px;">
                    </div>
                </div>
            </div>
        </div>

        <a class="left carousel-control" href="#myCarousel" data-slide="prev">
            <span><i class="material-icons carousalArrow">arrow_back</i></span>
            <span class="sr-only">Previous</span>
        </a>
        <a class="right carousel-control" href="#myCarousel" data-slide="next">
            <span><i class="material-icons carousalArrow">arrow_forward</i></span>
            <span class="sr-only">Next</span>
        </a>
    </div>
</div>

<section class="row">
    <div class="col-xs-12">
        <app-core-team-section id="finzyteam"></app-core-team-section>
    </div>
</section>

<section class="row">
    <div class="col-xs-12">
        <app-borrower-testimonials-section id="testimonials"></app-borrower-testimonials-section>
    </div>
</section>

<section class="row">
    <div class="col-xs-12">
        <app-we-have-been-in-the-news id="wehavebeeninthenews"></app-we-have-been-in-the-news>
    </div>
</section>

<section class="row grey-section">
    <div class="col-xs-12">
        <app-awards-and-accreditations id="awardsandaccreditations"></app-awards-and-accreditations>
    </div>
</section>

<section class="row contact-us" id="contact-us">
    <div class="col-xs-10 col-lg-10 col-lg-offset-1 col-xs-offset-1">
        <app-contact-us form-position="left"></app-contact-us>
    </div>
</section>

<section class="row">
    <div class="col-xs-12">
        <app-rbi-disclaimer class="rbi-disclaimer"></app-rbi-disclaimer>
    </div>
</section>

<app-footer></app-footer>
